import type { SYSTableDef } from "../../../../../../../_ovlclient/src/library/table/tableapi"

export let tblOfferingSettingsDef: SYSTableDef = {
  id: "QUTOfferingSettings",
  title: { dialogTitle: { translationKey: "QUTOfferingOfferingSettings" } },
  options: {},
  feature: "QUTOfferingSettings",
  server: {
    endpoint: "offering/settings",
  },
  database: {
    dataIdField: "CntctCode",
    dbInsertMode: "Manual",
  },
  columns: {
    U_PrtOfferingCadAttr: {
      ui: { labelTranslationKey: "QUTOfferingOfferingCadAttr" },
      list: {
        displayField: "CadAttr",
        valueField: "CadAttr",
      },
      schema: { nullable: false },
    },
    PrtOfferingCadUserField: {
      type: "int",
      ui: {
        labelTranslationKey: "QUTOfferingOfferingCadUserField",
        align: "center",
      },
    },
    U_PrtOfferingCadVal: {
      ui: { labelTranslationKey: "QUTOfferingOfferingCadVal" },
      schema: { maxLength: 50 },
    },
  },
}
